import { displayValueWithUnit, hasValue } from 'utils/valueFormatting/display.utils';

/**
 * Checks whether a ski report field contains information we can display.
 * The API uses "*" for missing information. Zero is valid, such as zero open lifts.
 */
export const hasSkiReportValue = (value) => hasValue(value) && value !== '*';

/**
 * Prepares a ski field for a WeatherCard, adding a unit only when one is provided.
 * Returns null for unavailable fields so the resort component can leave those rows out.
 */
export const formatSkiReportValue = (value, unit = '') =>
  hasSkiReportValue(value) ? displayValueWithUnit(value, unit) : null;
